<template>
    <form
        role="form"
        v-on="$listeners"
    >
        <p v-if="hasRequiredFields" class="form-requirements screen-reader-text">
            ({{ translate("Fields marked with an asterisk (*) are required") }})
        </p>
        <slot></slot>
    </form>
</template>

<script>
// NOTE: give the form an id, then controls OUTSIDE the form (like a submit button) can be lilnked to it using the form attribute: <submit form="my-form">
export default {
    name: "BaseForm",
    props: {
        hasRequiredFields: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style lang="scss">
.form-requirements {
    text-align: center;
    font-size: 0.8em;
}
</style>
